<template>
 
<h1>TESTIMONIALS</h1> <br><br><br>
<body class="bg-light">
    <main>
        <!-- Ui cards -->
        <section id="cards">
            <div class="container py-2">
                <div class="row pb-4">
                    <div class="col-12 text-center">
                        <div class="display-3">Our Team</div>
                    </div>
                </div>
                <!-- cards -->
                <div class="row">
                    <div class="col-lg-4 col-md-6 mb-4 pt-5">
                        <div class="card shadow-sm border-0">
                            <div class="card-body">
                                <div class="user-picture">
                                    <img src="https://i.postimg.cc/tgv4dTwc/chad.png" class="shadow-sm rounded-circle" height="130" width="130" />
                                </div>
                                <div class="user-content">
                                    <h5 class="text-capitalize user-name">Chad Hendricks</h5>
                                    <p class=" text-capitalize text-muted small blockquote-footer">Frontend Developer</p>
                                    <div class="small">
                                        <i class="fas fa-star text-warning"></i>
                                        <i class="fas fa-star text-warning"></i>
                                        <i class="fas fa-star text-warning"></i>
                                        <i class="fas fa-star-half-alt text-warning"></i>
                                        <i class="fas fa-star text-light"></i>
                                    </div>
                                    <p class="small text-muted mb-0">"Since we started working together, Mr Mantini has shown that he is a committed, hardworking and a talented developer. Always striving for excellence, never giving less than 110 percent. He definitely has a bright future in this industry".</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 mb-4 pt-5">
                        <div class="card shadow-sm border-0">
                            <div class="card-body">
                                <div class="user-picture">
                                    <img src="https://i.postimg.cc/d1zQXfqm/Whats-App-Image-2022-01-29-at-1-15-12-PM.jpg" class="shadow-sm rounded-circle" height="130" width="130" />
                                </div>
                                <div class="user-content">
                                    <h5 class="text-capitalize user-name">Nomvuyiseko Mpofu</h5>
                                    <p class=" text-capitalize text-muted small blockquote-footer">Frontend Developer</p>
                                    <div class="small">
                                        <i class="fas fa-star text-warning"></i>
                                        <i class="fas fa-star text-warning"></i>
                                        <i class="fas fa-star-half-alt text-warning"></i>
                                        <i class="fas fa-star text-light"></i>
                                        <i class="fas fa-star text-light"></i>
                                    </div>
                                    <p class="small text-muted mb-0">"Mr Mantini is a hardworker and always willing to learn, he has good wor ethics and respect for fellow staff members".</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 mb-4 pt-5">
                        <div class="card shadow-sm border-0">
                            <div class="card-body">
                                <div class="user-picture">
                                    <img src="https://i.postimg.cc/zfsj0nLb/Bongani.jpg" class="shadow-sm rounded-circle" height="130" width="130" />
                                </div>
                                <div class="user-content">
                                    <h5 class="text-capitalize user-name">Bongani Nomangola</h5>
                                    <p class=" text-capitalize text-muted small blockquote-footer">Full-stack developer</p>
                                    <div class="small">
                                        <i class="fas fa-star text-warning"></i>
                                        <i class="fas fa-star text-warning"></i>
                                        <i class="fas fa-star text-warning"></i>
                                        <i class="fas fa-star text-warning"></i>
                                        <i class="fas fa-star-half-alt text-warning"></i>
                                    </div>
                                    <p class="small text-muted mb-0">"We love working with Mr Mantini, he is a team player motivate others and good with communication".</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br>
                    <div class="col-lg-4 col-md-6 mb-4 pt-5">
                        <div class="card shadow-sm border-0">
                            <div class="card-body">
                                <div class="user-picture">
                                    <img src="https://i.postimg.cc/Y94qd7wC/siya.jpg" class="shadow-sm rounded-circle" height="130" width="130" />
                                </div>
                                <div class="user-content">
                                    <h5 class="text-capitalize user-name">Siyabonga Mkosana</h5>
                                    <p class=" text-capitalize text-muted small blockquote-footer">Full-stack developer</p>
                                    <div class="small">
                                        <i class="fas fa-star text-warning"></i>
                                        <i class="fas fa-star-half-alt text-warning"></i>
                                        <i class="fas fa-star text-light"></i>
                                        <i class="fas fa-star text-light"></i>
                                        <i class="fas fa-star text-light"></i>
                                    </div>
                                    <p class="small text-muted mb-0">Mr Mantini, has shown great workmanship and commitment since we started at Life Choices Coding Academy. He maintains a professional work culture, a good addition to any company because of his ability to adapt."</p>
                                </div>
                            </div>
                        </div>
                    </div>
                     <div class="col-lg-4 col-md-6 mb-4 pt-5">
                        <div class="card shadow-sm border-0">
                            <div class="card-body">
                                <div class="user-picture">
                                    <img src="../assets/testimonials/Ashley.jpg" class="shadow-sm rounded-circle" height="130" width="130" />
                                </div>
                                <div class="user-content">
                                    <h5 class="text-capitalize user-name">Ashley Kannemeyer</h5>
                                    <p class=" text-capitalize text-muted small blockquote-footer">full stack developer</p>
                                    <div class="small">
                                        <i class="fas fa-star text-warning"></i>
                                        <i class="fas fa-star text-warning"></i>
                                        <i class="fas fa-star-half-alt text-warning"></i>
                                        <i class="fas fa-star text-light"></i>
                                        <i class="fas fa-star text-light"></i>
                                    </div>
                                    <p class="small text-muted mb-0">"I have worked with Lilitha he is a goot team player, always strives to achieve the best results".</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 mb-4 pt-5">
                        <div class="card shadow-sm border-0">
                            <div class="card-body">
                                <div class="user-picture">
                                    <img src="../assets/testimonials/Bulela.jpeg" class="shadow-sm rounded-circle" height="130" width="130" />
                                </div>
                                <div class="user-content">
                                    <h5 class="text-capitalize user-name">Bulela Gomoshe</h5>
                                    <p class=" text-capitalize text-muted small blockquote-footer">Frontend developer</p>
                                    <div class="small">
                                        <i class="fas fa-star text-warning"></i>
                                        <i class="fas fa-star text-warning"></i>
                                        <i class="fas fa-star text-warning"></i>
                                        <i class="fas fa-star-half-alt text-warning"></i>
                                        <i class="fas fa-star text-light"></i>
                                    </div>
                                    <p class="small text-muted mb-0">"As a fellow student I think Lilitha has a reliable and caring personality. He loves participating  and engaging in class when given the opportunity.  I look forward to seeing what he will achieve in the future and highly reccomend him ."</p>
                                </div>
                            </div>
                        </div>
                    </div>
                   
                </div>
            </div>
            <!-- /cards -->
        </section>
        <!-- /Ui cards -->
    </main>

</body>
</template>

<script>
export default {

}
</script>

<style scoped>

/* title */

h1{
  padding-top: 40px;
  font-size: 50px;
  -webkit-animation: bounce-in-top 1.1s both;
	        animation: bounce-in-top 1.1s both;
}

/* ----------------------------------------------
 * Generated by Animista on 2022-2-22 9:59:43
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info. 
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

/**
 * ----------------------------------------
 * animation bounce-in-top
 * ----------------------------------------
 */
@-webkit-keyframes bounce-in-top {
  0% {
    -webkit-transform: translateY(-500px);
            transform: translateY(-500px);
    -webkit-animation-timing-function: ease-in;
            animation-timing-function: ease-in;
    opacity: 0;
  }
  38% {
    -webkit-transform: translateY(0);
            transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
            animation-timing-function: ease-out;
    opacity: 1;
  }
  55% {
    -webkit-transform: translateY(-65px);
            transform: translateY(-65px);
    -webkit-animation-timing-function: ease-in;
            animation-timing-function: ease-in;
  }
  72% {
    -webkit-transform: translateY(0);
            transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
            animation-timing-function: ease-out;
  }
  81% {
    -webkit-transform: translateY(-28px);
            transform: translateY(-28px);
    -webkit-animation-timing-function: ease-in;
            animation-timing-function: ease-in;
  }
  90% {
    -webkit-transform: translateY(0);
            transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
            animation-timing-function: ease-out;
  }
  95% {
    -webkit-transform: translateY(-8px);
            transform: translateY(-8px);
    -webkit-animation-timing-function: ease-in;
            animation-timing-function: ease-in;
  }
  100% {
    -webkit-transform: translateY(0);
            transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
            animation-timing-function: ease-out;
  }
}
@keyframes bounce-in-top {
  0% {
    -webkit-transform: translateY(-500px);
            transform: translateY(-500px);
    -webkit-animation-timing-function: ease-in;
            animation-timing-function: ease-in;
    opacity: 0;
  }
  38% {
    -webkit-transform: translateY(0);
            transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
            animation-timing-function: ease-out;
    opacity: 1;
  }
  55% {
    -webkit-transform: translateY(-65px);
            transform: translateY(-65px);
    -webkit-animation-timing-function: ease-in;
            animation-timing-function: ease-in;
  }
  72% {
    -webkit-transform: translateY(0);
            transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
            animation-timing-function: ease-out;
  }
  81% {
    -webkit-transform: translateY(-28px);
            transform: translateY(-28px);
    -webkit-animation-timing-function: ease-in;
            animation-timing-function: ease-in;
  }
  90% {
    -webkit-transform: translateY(0);
            transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
            animation-timing-function: ease-out;
  }
  95% {
    -webkit-transform: translateY(-8px);
            transform: translateY(-8px);
    -webkit-animation-timing-function: ease-in;
            animation-timing-function: ease-in;
  }
  100% {
    -webkit-transform: translateY(0);
            transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
            animation-timing-function: ease-out;
  }
}

/* title ends */
/* ==== Cards using Bootstrap === */

#cards .card {
        
    border-radius: 20px;
    min-height: 100%;
    box-shadow: rgb(0, 0, 0, 0.9);
}

.card:hover {
  transform: scale(1.1);
}

.card-body{
        
     height: 190px;   
}

.row{
        margin-left: 100px;
}

.blockquote-footer{
        font-size: 15px;
        padding-right: 60px !important;
}
.card p{
        font-size: 13px;
        margin-top: 20px;
}

#cards .heading-border {
    position: absolute;

    width: 100%;
    top: 60%;
}

#cards .card .user-picture img {
    position: absolute;
    top: -20%;
    
    right: 10%;
    background: #f8f9fa!important;
    padding: 10px;
}

#cards .card .user-content .user-name {
    margin-right: 150px;
}
</style>